import { Context } from "../../context";
import { CameraController, CameraLandmark, CameraMode } from "../controller";

export interface DeferredCameraTransition {
  cb: () => void;
  remainingFrames: number;
}

export interface CameraModeOptions {
  fromManager?: boolean;
  focusedID?: number;
  initData?: {
    mode: CameraMode;
    landmark: CameraLandmark;
  };
  landmark?: CameraLandmark;
  fromInteraction?: boolean;
}

/**
 * Strategy class for CameraController. We typically use the CameraControls
 * from [here](https://github.com/yomotsu/camera-controls/), but that isn't
 * a requirement (you can update the camera positions directly if you prefer).
 *
 * The strategy is responsible for setting the state required for it's behaviour
 * (in the init() method), and also for reverting that state (in the teardown()
 * method). An optional update() method is useful for cameras that depend on state
 * in the scene / beyond the user's mouse controls.
 */
export class ControllerStrategy {
  registered?: CameraController;
  lastFrameNum?: number;

  protected deferedTransitions: Set<DeferredCameraTransition> = new Set();

  init(_context: Context, _options?: CameraModeOptions): ControllerStrategy {
    return this;
  }

  teardown(): void {}
  update(_deltaS: number, _gameTimeDelta: number, _frameNum?: number): void {}

  protected resolveDeferals(frameNum: number) {
    if (this.lastFrameNum == undefined) {
      return;
    }

    // TODO: gracefully handle seek events here?
    for (const transition of this.deferedTransitions) {
      transition.remainingFrames -= frameNum - this.lastFrameNum;
      if (transition.remainingFrames <= 0) {
        transition.cb();
        this.deferedTransitions.delete(transition);
      }
    }
  }
}
